/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
const CALLBACK_NAME = 'iqhApp2jsBridge.callback';
const TRIGGER_NAME = 'iqhApp2jsBridge.trigger';
const ua = navigator.userAgent.toLowerCase();
const isIOS = /iphone|ipad|ipod/.test(ua);
const isAndroid = /android/.test(ua);
const isOhos = /ohos/.test(ua);

function sendIOS(name, params) {
  try {
    window.webkit.messageHandlers[name].postMessage(params);
  } catch (e) {
    global.console.log('ios消息发送失败1', e.message);
  }
}

function sendAndroid(name, params) {
  try {
    if (params) {
      window.android[name](params);
    } else {
      window.android[name]();
    }
  } catch (e) {
    global.console.log('android消息发送失败', e.message);
  }
}

function sendOhos(name, params) {
  try {
    if (params) {
      let msg = dsBridge.call(`ohos.${name}`, params);
      updateMsg(msg);
    } else {
      let msg = dsBridge.call(`ohos.${name}`);
      updateMsg(msg);
    }
  } catch (e) {
    global.console.log('鸿蒙消息发送失败', e.message);
  }
}

const send = (name, params) => {
  const data = JSON.stringify(params);
  switch (true) {
    case isIOS:
      sendIOS(name, data);
      break;
    case isAndroid:
      sendAndroid(name, data);
      break;
    case isOhos:
      sendOhos(name, data);
      break;
    default:
      global.console.log('不是移动端', name, params);
  }
};

const getToken = (() => {
  let num = 0;
  return () => {
    num += 1;
    return `${num}`;
  };
})();

function clone(base, obj) {
  if (arguments.length === 1) {
    obj = base;
    base = {};
  }
  // for (let key in obj) {
  //     if (obj.hasOwnProperty(key)) {
  //         base[key] = obj[key];
  //     }
  // }
  Object.keys(obj || {}).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      base[key] = obj[key];
    }
  });
  return base;
}

window[CALLBACK_NAME] = (args) => {
  const name = args.__name;
  const token = args.__token;
  if (!name || !token) return;
  if (window[CALLBACK_NAME][name] && window[CALLBACK_NAME][name][token]) {
    window[CALLBACK_NAME][name][token](args);
    delete window[CALLBACK_NAME][name][token];
  }
};

// app主动触发js，把方法放到数组中
window[TRIGGER_NAME] = (args) => {
  const name = args.__name;
  const token = args.__token;
  if (!name || !token) return;
  if (window[TRIGGER_NAME][name]) {
    window[TRIGGER_NAME][name].forEach((fn) => {
      if (fn) fn(args);
    });
  }
};

function sendApp(name, params, needCallback) {
  let token;
  if (!!needCallback === false) {
    return send(name, params);
  }
  return new Promise((resolve, reject) => {
    token = getToken();
    window[CALLBACK_NAME][name] = window[CALLBACK_NAME][name] || {};
    window[CALLBACK_NAME][name][token] = (args) => {
      args = JSON.parse(args || '{}');
      if (args.__status === 1) {
        delete args.__name;
        delete args.__token;
        delete args.__status;
        delete args.__message;
        resolve(args);
      } else {
        reject(args.__message);
      }
    };
    send(name, clone({ __token: token }, Object.assign(params, { __name: name })));
  });
}

sendApp.on = (name, callback) => {
  window[TRIGGER_NAME][name] = window[TRIGGER_NAME][name] || [];
  window[TRIGGER_NAME][name].push((args) => {
    const token = args.__token;
    // const data = clone({}, args);
    delete args.__name;
    delete args.__token;
    const promise = callback(clone({}, args));
    if (promise && promise.then) {
      promise.then(
        (data) => {
          const result = clone({
            __token: token,
            __status: 0,
          }, data);
          send(name, result);
        },
        (message) => {
          let sendData = {};
          let status = 1;
          if (typeof message === 'object') {
            sendData = message;
            status = sendData.status || status;
            message = sendData?.message;
            sendData = sendData?.data || {};
          }
          const result = clone({
            __token: token,
            __status: status,
            __message: message,
          }, sendData);
          send(name, result);
        },
      );
    }
  });
};

export default sendApp;
